import { AxiosResponse } from 'axios';
import { useAppMutation } from './useAppMutation';

export interface CheckoutBody {
  quantity: number;
  // Buying for yourself: the server pre-fills the cart with the buyer as its participant.
  forMyself: boolean;
}

interface CheckoutResponse {
  checkoutUrl: string;
}

export const useCheckoutCourse = (courseId: string | undefined) => {
  const { mutate, isPending } = useAppMutation<
    AxiosResponse<CheckoutResponse>,
    Error,
    CheckoutBody
  >('post', `/Course/${courseId}/checkout`);

  const onCheckoutCourse = (
    body: CheckoutBody,
    options?: {
      onSuccess?: (data: AxiosResponse<CheckoutResponse>) => void;
      onError?: (error: Error) => void;
    }
  ) => {
    mutate(body, options);
  };

  return { onCheckoutCourse, isPending };
};
